import { useEffect, useState } from "react";
import { buscarInteressadoAnuncioByAnuncioIdService } from "../../../services/buscarInteressadoAnuncioByAnuncioIdService";
import { InteressadoAnuncio } from "../../../interfaces/InteressadoAnuncio";

export const useInteressadoAnuncio = (anuncioId: number | null) => {
  const [interessadoAnuncio, setInteressadoAnuncio] = useState<
    InteressadoAnuncio[]
  >([]);
  const [qtdInteressadoAnuncio, setQtdInteressadoAnuncio] = useState<
    number | null
  >(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      if (anuncioId) {
        setLoading(true);
        try {
          const data = await buscarInteressadoAnuncioByAnuncioIdService(
            anuncioId
          );

          setInteressadoAnuncio(data);
          setQtdInteressadoAnuncio(data.length);
        } catch (err) {
          console.error("Erro ao buscar interesse do anuncio:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetch();
  }, [anuncioId]);

  return { interessadoAnuncio, qtdInteressadoAnuncio, loading };
};
